export const TimeEntryAdjustmentStatusConst = {
  PENDING: 1,
  APPROVED: 2,
  REJECTED: 3,
};

export const TimeEntryAdjustmentStatusLabel: Record<number, string> = {
  [TimeEntryAdjustmentStatusConst.PENDING]: "Pendente",
  [TimeEntryAdjustmentStatusConst.APPROVED]: "Aprovado",
  [TimeEntryAdjustmentStatusConst.REJECTED]: "Rejeitado",
};
